// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","461":"b637e9a5","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"12f6ec93a30eaba72a2d","293":"78915e9ffe6ea262e1d3","461":"85cb3f8e8954972ee4a5","518":"d6c4b2fe486df1dcb676","779":"97bf23964dba3594f26d"}[chunkId] + ".js";
};